export default __webpack_public_path__ + "b434d6c03a86625111a3d40abcd84e04.png";